export default {
  costCentres: [],
  costCentre: undefined,
};
